/* Pre&Post Pulse \u2014 Monthly Box sales banner (Nov 2026)
   Everyone on the Monthly Box page sees: November sold out + live December countdown,
   clear pricing, "for yourself or as a gift", Christmas cutoff, and a gift option on the buy form.
   Countdown number = window.PPP_LEFT (set by a small Liquid section from real Shopify inventory). */
(function () {
  if (!/\/products\/pre-post-pulse-monthly-box/.test(location.pathname)) return;

  var TEN_OFF = ["letsgo10","crunch10","hustle10","pulse10","victoria10","jen10","julia10","hallie10","alyssa10","haley10","brooke10","emma10","elion10","nichole10","murray10","epicpulse"];
  function getCk(n){var m=document.cookie.match(new RegExp("(?:^|; )"+n+"=([^;]*)"));return m?decodeURIComponent(m[1]):"";}
  var code=(getCk("discount_code")||new URLSearchParams(location.search).get("discount")||"").toLowerCase();
  var hasTen=TEN_OFF.indexOf(code)>-1;
  var isEmilie=code==="emiliexmas";
  var left=typeof window.PPP_LEFT==="number"?window.PPP_LEFT:null;
  var START=24;

  var css="#ppp-offer{box-sizing:border-box;margin:12px auto 8px;max-width:1100px;width:calc(100% - 24px);border-radius:16px;padding:20px 18px 22px;background:#262628;color:#fff;text-align:center;font-family:inherit;box-shadow:0 10px 28px rgba(0,0,0,.25)}"+
  "#ppp-offer .so{display:inline-block;background:#ff6a00;color:#fff;font-weight:900;font-size:13px;letter-spacing:.14em;text-transform:uppercase;padding:6px 12px;border-radius:999px}"+
  "#ppp-offer .big{font-size:clamp(30px,8.5vw,52px);line-height:1.05;font-weight:900;margin:12px 0 4px}"+
  "#ppp-offer .big b{color:#ff8a2a}"+
  "#ppp-offer .bar{height:12px;background:#444;border-radius:999px;overflow:hidden;margin:12px auto 6px;max-width:460px}"+
  "#ppp-offer .bar i{display:block;height:100%;background:linear-gradient(90deg,#ff6a00,#ffa64d);border-radius:999px}"+
  "#ppp-offer .tiny{font-size:13px;opacity:.75}"+
  "#ppp-offer .price{margin:14px auto 0;font-size:18px;font-weight:800}"+
  "#ppp-offer .price s{opacity:.6;font-weight:600}"+
  "#ppp-offer .price .first{display:block;color:#ff8a2a;font-size:17px;margin-top:4px}"+
  "#ppp-offer .gift{margin:14px auto 0;font-size:16px;line-height:1.4}"+
  "#ppp-offer .xmas{display:inline-block;margin-top:8px;font-size:14px;font-weight:700;border:1px solid #ff8a2a;color:#ffb070;padding:5px 12px;border-radius:999px}"+
  "#ppp-offer .btn{display:inline-block;margin-top:16px;background:#ff6a00;color:#fff;text-decoration:none;font-weight:900;font-size:19px;padding:14px 30px;border-radius:999px}"+
  "#ppp-giftbox{border:2px solid #ff6a00;border-radius:12px;padding:12px 14px;margin:12px 0;font-family:inherit;background:#fff7f0}"+
  "#ppp-giftbox label{font-weight:700;cursor:pointer;display:flex;gap:8px;align-items:center;font-size:16px}"+
  "#ppp-giftbox .f{display:none;margin-top:10px}"+
  "#ppp-giftbox.on .f{display:block}"+
  "#ppp-giftbox input[type=text],#ppp-giftbox textarea{width:100%;box-sizing:border-box;border:1px solid #ccc;border-radius:8px;padding:10px;font:inherit;margin:4px 0 8px}"+
  "#ppp-giftbox .n{font-size:13px;color:#555}";
  var st=document.createElement("style");st.textContent=css;document.head.appendChild(st);

  /* ---------- banner ---------- */
  var count;
  if(left===null){count='<div class="big">December boxes are <b>going fast</b></div>';}
  else if(left<=0){count='<div class="big"><b>December is sold out</b></div><div class="tiny">Join now for January.</div>';}
  else{
    var pct=Math.max(6,Math.min(100,Math.round(left/START*100)));
    count='<div class="big">Only <b>'+left+'</b> December box'+(left===1?"":"es")+' left</div>'+
      '<div class="bar"><i style="width:'+pct+'%"></i></div><div class="tiny">Live count. It drops with every order.</div>';
  }
  var price=hasTen
    ? '<div class="price">$42.99/month \u00b7 skip or cancel anytime<span class="first">Your first box: <s>$42.99</s> $32.99 ($10 off already applied)</span></div>'
    : '<div class="price">$42.99/month \u00b7 skip or cancel anytime</div>';

  var b=document.createElement("div");b.id="ppp-offer";
  b.innerHTML='<span class="so">\ud83d\udd25 November sold out</span>'+count+price+
    '<div class="gift">Discover it for yourself, or give it as a gift. \ud83c\udf81</div>'+
    '<span class="xmas">\ud83c\udf84 Order by Dec 12 for Christmas</span><br>'+
    '<a class="btn" href="#ppp-buy">Get my first box \u2193</a>';

  function place(){
    var main=document.querySelector("main");if(!main)return false;
    var old=document.getElementById("ppp-offer");if(old)old.remove();
    main.insertBefore(b,main.firstChild);return true;
  }

  /* ---------- gift option on the buy form (skipped for Emilie: her own form) ---------- */
  function giftBox(){
    if(isEmilie||document.getElementById("ppp-giftbox"))return true;
    var form=document.querySelector('form[action*="/cart/add"]');if(!form)return false;
    form.id=form.id||"ppp-buy";
    var a=document.querySelector('#ppp-offer .btn');if(a)a.setAttribute("href","#"+form.id);
    var g=document.createElement("div");g.id="ppp-giftbox";
    g.innerHTML='<label><input type="checkbox" id="ppp-g-on"> \ud83c\udf81 This is a gift</label>'+
      '<div class="f">'+
      '<input type="text" id="ppp-g-to" placeholder="Who is it for? (their name)" maxlength="60">'+
      '<textarea id="ppp-g-msg" rows="3" maxlength="200" placeholder="Gift message for the card (optional)"></textarea>'+
      '<div class="n">Works for a one-time box or a monthly membership. Enter their address at checkout. Regular shipping applies. The $10 first-box offer is for your own box, so it is not applied to gifts.</div>'+
      '</div>';
    form.parentNode.insertBefore(g,form);
    var on=g.querySelector("#ppp-g-on");
    function hid(name,val){var i=form.querySelector('input[name="'+name+'"]');if(!val){if(i)i.remove();return;}if(!i){i=document.createElement("input");i.type="hidden";i.name=name;form.appendChild(i);}i.value=val;}
    function sync(){
      var isOn=on.checked;g.classList.toggle("on",isOn);
      hid("properties[Gift]",isOn?"Yes":"");
      hid("properties[Gift for]",isOn?g.querySelector("#ppp-g-to").value.trim():"");
      hid("properties[Gift message]",isOn?g.querySelector("#ppp-g-msg").value.trim():"");
      if(isOn&&hasTen){document.cookie="discount_code=; path=/; max-age=0";}
    }
    function dropCode(){
      if(!(on.checked&&hasTen))return;
      document.cookie="discount_code=; path=/; max-age=0";
      fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({discount:""})}).catch(function(){});
    }
    g.addEventListener("input",sync);g.addEventListener("change",function(){sync();dropCode();});
    form.addEventListener("submit",function(){dropCode();setTimeout(dropCode,1500);});
    return true;
  }

  var tries=0;(function go(){var ok1=place();var ok2=giftBox();if((!ok1||!ok2)&&tries++<40)setTimeout(go,250);})();
})();